import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const FoodItemMenuBranchLink = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams()
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
  } = useContext(RestaurantContext);
  // States hook here
  //new item
  let [newItem, setNewItem] = useState(null);
  //new Row
  const [newRow,setNewRow]=useState([]);

  const getItemBranchLink = async () => {
    const url = BASE_URL +"/settings/item-branch-wise/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        const editItemBranch = res.data;
        if(editItemBranch){
          setNewItem({
            id: editItemBranch.food_id,
            name: editItemBranch.food_name,
          });
          const menuBranchLink = editItemBranch.departments.map((department) => {
            return (
              {
                ...department,
                department_status: department.department_status
              }
            )
          });
          setNewRow(menuBranchLink)
        }
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(id){
      getItemBranchLink()
    }
  }, [id]);

  //set items status hook
  const handleMenuStatus = (index,status) => {
    if(newRow[index].branch && newRow[index].branch?.length){
      newRow[index].department_status = status ? 0 : 1;
      newRow[index].branch = newRow[index].branch.map((branch) => {
        return {
          ...branch,
          branch_status: status ? 0 : 1
        }
      });
      setNewRow([...newRow]);
    }
  };

  const handleBranchStatus = (index,ind,status) => {
    if(newRow[index].branch){
      newRow[index].branch[ind].branch_status = status ? 0 : 1;
      setNewRow([...newRow]);
    }
  };

  const itemMenuBranchWiseLink = async () => {

    let formData = {
      item_id: newItem.id,
      link: newRow,
    };

    if(newRow.length){
      setLoading(true);
      const endPoint = `/settings/item-branch-wise/` + newItem.id;
      const url = BASE_URL + endPoint;
      const method = "put";
      try {
        const res = await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data){
          setLoading(false);
          toast.success(<span>{res.data?.message}</span>, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          history.push("/dashboard/manage/food/all-items");
        }
      } catch (error) {    
        setLoading(false);
        toast.error(`${_t(t("Please try again later"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }else{
      toast.error(`${_t(t("Menu link is required"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (newItem) {
      if(newRow.length > 0){
        itemMenuBranchWiseLink();
      }
      else{
        toast.error(`${_t(t("Please add notes"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all the required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  return (
    <>
    <Helmet>
      <title>{_t(t("Food Item Branch Link"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <div className={`${dataPaginating && "loading"}`}></div>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {loading === true ? (
                    tableLoading()
                  ) : (
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Food Item Branch Link"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-2 mb-3 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="col-12">
                          <div className="row">
                            <div className="col-12">
                              <span className="text-truncate font-weight-md xxslg-text text-capitalize">
                                {newItem?.name}
                              </span>
                            </div>                   
                          </div>
                          <div className="mt-3 font-weight-md xslg-text">
                            Menu Branch Link:
                          </div>

                          <div className="mt-2 pr-1" style={{height:"calc(100vh - 22.5rem)",overflow: "auto"}}>
                            {
                              newRow && newRow.length ? (
                                <div>
                                  {newRow?.map((item, index) => {
                                    return (
                                      <>
                                        <div key={index} className="mb-2 d-flex align-items-center">
                                          <input
                                            type="checkbox"
                                            className="form-check-input mt-0 ml-1"
                                            id={item.department_name}
                                            checked={item.department_status}
                                            onChange={() => handleMenuStatus(index,item.department_status)}
                                          />
                                          <label htmlFor={item?.department_name} className="w-50 pl-2 text-truncate font-weight-md xslg-text text-capitalize">
                                            {item?.department_name}
                                          </label>
                                        </div>

                                        {item.branch && item.branch.length && (item.branch.map((branch, ind) => (
                                            <div key={ind} className={`${ind === (item.branch.length -1) ? "mb-3" : "mb-1"} d-flex align-items-center ml-3`}>
                                              <input
                                                type="checkbox"
                                                className="form-check-input mt-0"
                                                id={item?.department_name + branch?.branch_name}
                                                checked={branch.branch_status}
                                                onChange={() => handleBranchStatus(index,ind,branch.branch_status)}
                                              />
                                              <label htmlFor={item?.department_name + branch?.branch_name} className="w-50 pl-2 text-truncate lg-text text-capitalize">
                                                {branch?.branch_name}
                                              </label>
                                            </div>
                                          ))
                                        )}
                                      </>
                                    );
                                  }
                                  )}
                                </div>
                              ) : ""
                            }
                          </div>
                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                type="button"
                                className="btn rounded hov-btn mr-3"
                                onClick={()=>(history.push("/dashboard/manage/food/all-items"))}
                                //   data-dismiss="modal"
                                >
                                  <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                </button>
                                <button
                                disabled={loading}
                                type="submit"
                                className="btn btn-primary rounded"
                                >
                                  <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                </button>                                                    
                              </div>                                                    
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
  </>
  )
}

export default FoodItemMenuBranchLink
